export{}
declare global {
    interface Array<T> {
        first(): T;
    }
}

if (!Array.prototype.first) {
    Array.prototype.first = function<T>(this: T[]): T | undefined {
        return this.find(x => x !== undefined);
    };
}
